export const SET_STEP = 'createAccount/SET_STEP'
export const SET_PASSWORD = 'createAccount/SET_PASSWORD'
export const SET_ACCOUNT = 'createAccount/SET_ACCOUNT'
export const SET_SHOW_PRIVATEKEY = 'createAccount/SET_SHOW_PRIVATEKEY'
export const SET_CONFIRM_MNEMONIC = 'createAccount/SET_CONFIRM_MNEMONIC'
export const SET_SHOW_KEYSTORE_TEXT = 'createAccount/SET_SHOW_KEYSTORE_TEXT'
export const SET_RANDOM_WORDS = 'createAccount/SET_RANDOM_WORDS'

export const setStep = step => dispatch =>
  dispatch({
    type: SET_STEP,
    step,
  })

export const setPassword = password => dispatch =>
  dispatch({
    type: SET_PASSWORD,
    password,
  })

export const setRandomWords = data => dispatch =>
  dispatch({
    type: SET_RANDOM_WORDS,
    data,
  })

export const setShowKeystoreText = data => dispatch =>
  dispatch({
    type: SET_SHOW_KEYSTORE_TEXT,
    data,
  })

export const setAccount = data => dispatch =>
  dispatch({
    type: SET_ACCOUNT,
    data,
  })

export const setShowPrivateKey = data => dispatch =>
  dispatch({
    type: SET_SHOW_PRIVATEKEY,
    data,
  })

export const setConfirmMnemonic = data => dispatch =>
  dispatch({
    type: SET_CONFIRM_MNEMONIC,
    data,
  })
